import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, forwardRef, theme } from '@chakra-ui/react';
export const ToastLeftContent = forwardRef((props, ref) => {
    return _jsx(Flex, { ref: ref, p: theme.sizes['4'], mr: `-${theme.sizes['4']}`, ...props });
});
